/*
 * ErrorBoundary messages
 *
 * This contains all the text for the ErrorBoundary component
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  headline: {
    id: 'components.ErrorBoundary.headline',
    defaultMessage: 'Oops, something went wrong here',
  },
  login: {
    id: 'components.ErrorBoundary.login',
    defaultMessage: 'Maybe you need to {cta}.',
  },
  cta: {
    id: 'components.ErrorBoundary.cta',
    defaultMessage: 'log in again',
  },
});
